'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _pollerShape = require('./pollerShape');

var _pollerShape2 = _interopRequireDefault(_pollerShape);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * # poller轮询
 *
 * 1. 轮询功能，通过subscribe订阅轮询结果。
 * 2. 提供start, stop, remove控制轮询
 *
 * > see: https://github.com/emmaguo/angular-poller/blob/master/angular-poller.js
 */
var Poller = function () {
  function Poller(opt) {
    (0, _classCallCheck3.default)(this, Poller);

    _propTypes2.default.checkPropTypes(_pollerShape2.default, opt, 'pollerOptions', 'Beatle.Poller');
    /**
     * ### 私有属性
     *
     * | 属性名 | 描述 |
     * |: ------ |: ------ |
     * | _option `pollerShape` | 初始化轮询配置项 |
     * | _current `Promise` | 每次轮询产生的结果对象 |
     * | _interval `Interval` | 轮询定时器 |
     * | _stopTimestamp `number` | 当点击停止时会记录一个时间戳，此时未轮询结束的`_current`可判断是否还要接收 |
     * | _watchers `Array` | 每次轮询结果回来时，触发的回调列表 |
     */
    this._option = Object.assign({
      delay: 5000,
      smart: false,
      action: null,
      checkResult: function checkResult() {
        return true;
      },
      catchError: null
    }, opt);

    if (!this._option.delay) {
      this._option.delay = 5000;
    }
    this._current = null;
    this._interval = null;
    this._stopTimestamp = null;
    this._watchers = [];
  }

  /**
   * ### 公开方法
   * | 方法 | 参数类型 | 描述 |
   * |: ------ |: ------ |: ------ |
   * | then | success `Function`, error `Function` | 注册回调队列，每次轮询产生结果时触发 |
   * | subscribe | watcher `Function` | 开始订阅，同上注册回调队列，并且启动轮询 |
   * | unsubscribe | N/A | 取消订阅，并关闭轮询 |
   * | remove | N/A | 同上 |
   * | start | N/A | 开始轮询 |
   * | stop | N/A | 停止轮询 |
   * | tick | N/A | 等当前产生结果后跳到下一个轮询 |
   */


  (0, _createClass3.default)(Poller, [{
    key: 'then',
    value: function then(success, error) {
      var watcher = function watcher(err, res) {
        if (err) {
          error && error(err);
        } else {
          success && success(res);
        }
      };
      this._watchers.push(watcher);
    }
  }, {
    key: 'subscribe',
    value: function subscribe(watcher) {
      this._watchers.push(watcher);
      this.start();
    }
  }, {
    key: 'tick',
    value: function tick(promise) {
      var _this = this;

      var timestamp = new Date();
      this._current = promise || this._option.action();
      return this._current.then(function (res) {
        _this._current._resolved = true;
        _this._current._result = res;
        if (!_this._stopTimestamp || timestamp >= _this._stopTimestamp) {
          _this._watchers.forEach(function (watcher) {
            watcher(null, res);
          });
        }
      }, function (err) {
        if (!_this._stopTimestamp || timestamp >= _this._stopTimestamp) {
          _this._watchers.forEach(function (watcher) {
            watcher(err);
          });
          if (_this._option.catchError) {
            _this._option.catchError(err);
          }
        }
      });
    }
  }, {
    key: 'hasTick',
    value: function hasTick(res) {
      if (!this._current || this._current._resolved && this._option.checkResult(res) !== false) {
        return true;
      } else {
        this.remove();
        return false;
      }
    }
  }, {
    key: 'start',
    value: function start(promise) {
      var _this2 = this;

      this.stop();
      this._stopTimestamp = null;

      this.tick(promise);
      this._interval = setInterval(function () {
        if (_this2._option.smart) {
          _this2._current.then(function () {
            if (_this2.hasTick(_this2._current._result)) {
              _this2.start();
            }
          });
        } else {
          if (_this2.hasTick(_this2._current._result)) {
            _this2.tick();
          }
        }
      }, this._option.delay);
    }
  }, {
    key: 'stop',
    value: function stop() {
      clearInterval(this._interval);
      this._stopTimestamp = new Date();
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe() {
      this.stop();
      this._watchers = [];
    }
  }, {
    key: 'remove',
    value: function remove() {
      this.stop();
      this._watchers = [];
    }
  }]);
  return Poller;
}();

exports.default = Poller;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/poller.js
// module id = 51
// module chunks = 0